import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Separator.module.scss';

export interface ISeparatorProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    orientation?: 'horizontal' | 'vertical';
}

export const Separator: React.FC<ISeparatorProps> = ({ orientation = 'horizontal', className, ...props }) => {
    return <div className={classNames(styles.separator, className, styles[`orientation-${orientation}`])} {...props} />;
};
